export const BaseURL = process.env.REACT_APP_BASE_API_URL;

export const getCountry = process.env.REACT_APP_GET_COUNTRY;

export const extApiKey = process.env.REACT_APP_EXT_KEY;